import React, { Component } from 'react';
import { Button, Input, Select, Icon } from 'antd';
import API_URL from '../../../../../common/url';
import ExportUtil from '../../../../../common/ExportUtil';
import SearchRetrieve from '../../../../common/SearchRetrieve.new.js';
import SelectBa from '../../../components/SelectBa';

const { Option } = Select;

class Filter extends Component {
    constructor(props) {
        super(props);
        const { curRole } = sessionStorage;
        this.show = curRole !== 'BA';
        this.state = {
            expand: false,
        };
    }

    search = () => {
        this.props.search();
    }

    export = () => {
        const { sortParams, searchParams } = this.props;
        const url = API_URL.requestDataAnalysis.exportRemainingJdePendingRequest;
        ExportUtil.export({ ...sortParams, ...searchParams }, null, url);
    }

    handleKeyPress = e => {
        if (e.charCode === 13) {
            this.search();
        }
    }

    handleChange = (value, key) => {
        const { searchParams, onChange } = this.props;
        switch (key) {
            case 'customerCompany':
            case 'ba': 
            case 'pmUser':
            case 'mainTalUser':
            {
                const { value: id, text: name } = value;
                searchParams[`${key}Id`] = id;
                searchParams[`${key}Name`] = name;
                onChange(searchParams);
                break;
            }
            case 'customerBaName': {
                const { lastLeaf, checkedKeys, expandedKeys } = value;
                searchParams.lastLeaf = lastLeaf;
                searchParams.checkedKeys = checkedKeys;
                searchParams.expandedKeys = expandedKeys;
                searchParams.customerBaNameIds = (lastLeaf || []).map(i => i.id).join(',');
                searchParams.customerBaNameNames = (lastLeaf || []).map(i => i.title).join(',');
                onChange(searchParams);
                break;
            }
            default:
                searchParams[key] = value;
                onChange(searchParams);
                break;
        }
    }

    toggleHeight = () => {
        this.setState((prevState) => ({
            expand: !prevState.expand,
        }));
    }

    render () {
        const { searchParams, businessList, areaOptions } = this.props;
        const { expand } = this.state;
        const { lastLeaf, checkedKeys, expandedKeys } = searchParams;

        const businessOption = businessList.map(i => <Option key={i.typeConfigureId}>{i.typeValue}</Option>);
        const areaOption = areaOptions.map(d => <Option key={String(d.value)} title={d.label}>{d.label}</Option>);
        return (
            <div style={{ marginBottom: 16 }}>
                <div className={`search-bar expand ${expand ? 'expanded' : ''}`}>
                    {
                        this.show &&
                        <div className="expand-box">
                            <a onClick={this.toggleHeight}>
                                {expand ? "收起" : "展开"}
                                <Icon className="expand-icon" type={expand ? "up" : "down"} />
                            </a>
                        </div>
                    }
                    <div className="search-item">
                        <div className="ui-label">JDE主项目号</div>
                        <Input
                            placeholder="请输入"
                            style={{ width: 140 }}
                            onKeyPress={this.handleKeyPress}
                            value={searchParams.investigationJdeMainCode}
                            onChange={e => this.handleChange(e.target.value, 'investigationJdeMainCode')}
                        />
                    </div>
                    <div className="search-item">
                        <div className="ui-label">项目简称</div>
                        <Input
                            placeholder="请输入"
                            style={{ width: 160 }}
                            value={searchParams.investigationName}
                            onKeyPress={this.handleKeyPress}
                            onChange={e => this.handleChange(e.target.value, 'investigationName')}
                        />
                    </div>
                    <div className="search-item">
                        <div className="ui-label">JDE项目号</div>
                        <Input
                            placeholder="请输入"
                            style={{ width: 140 }}
                            value={searchParams.investigationJdeCode}
                            onKeyPress={this.handleKeyPress}
                            onChange={e => this.handleChange(e.target.value, 'investigationJdeCode')}
                        />
                    </div>
                    <div className="search-item">
                        <div className="ui-label">客户全名</div>
                        <SearchRetrieve
                            keyword='customerCompanyName'
                            style={{ width: 160 }}
                            placeholder="输入客户名称或代码检索"
                            value={searchParams.customerCompanyName}
                            params={{ limit: 20 }}
                            url={API_URL.investigation.queryCustomerCompanyByName}
                            config={{ id: 'customerCompanyId', name: 'customerCompanyName' }}
                            onChange={(option) => this.handleChange(option, 'customerCompany')}
                        />
                    </div>
                    <div className="search-item">
                        <label htmlFor="" className="ui-label">业务线</label>
                        <Select
                            allowClear={true}
                            placeholder="请选择"
                            style={{width: 140}}
                            value={searchParams.lineOfBusinessId}
                            onChange={value => this.handleChange(value, 'lineOfBusinessId')}
                        >
                            {businessOption}
                        </Select>
                    </div>
                    <div className="search-item">
                        <label htmlFor="" className="ui-label">项目领域</label>
                        <Select
                            allowClear={true}
                            style={{ width: 140 }}
                            showSearch
                            filterOption= {(input, option) => option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0}
                            placeholder="输入领域名称检索"
                            value={searchParams.investigationAreaId}
                            onChange={value => this.handleChange(value, 'investigationAreaId')}
                        >
                            {areaOption}
                        </Select>
                    </div>
                    <div className="search-item">
                        <label htmlFor="" className="ui-label">PM</label>
                        <SearchRetrieve
                            keyword='keyword'
                            style={{ width: 140 }}
                            placeholder="输入姓名/工号检索"
                            value={searchParams.pmUserName}
                            params={{ limit: 20 }}
                            url={API_URL.investigation.queryUserByKey}
                            config={{ id: 'userId', name: 'userCompellation', code: 'employeeCode', show: 'user' }}
                            onChange={value => this.handleChange(value, 'pmUser')}
                        />
                    </div>
                    <div className="search-item">
                        <label htmlFor="" className="ui-label">领域leader</label>
                        <SearchRetrieve
                            keyword='leaderName'
                            style={{ width: 140 }}
                            placeholder="输入姓名/工号检索"
                            value={searchParams.mainTalUserName}
                            params={{ limit: 20, status: 'ALL' }}
                            url={API_URL.user.queryLeaderList}
                            config={{ id: 'userId', name: 'userCompellation', code: 'employeeCode', show: 'user' }}
                            onChange={value => this.handleChange(value, 'mainTalUser')}
                        />
                    </div>
                </div>
                <div className="search-bar flex-end">
                    <div className="search-item">
                        <Button type="primary" onClick={this.search}>搜索</Button>
                        <Button type="primary" onClick={this.export}>导出</Button>
                    </div>
                </div>
                <SelectBa
                    ref={el => this.selectBaRef = el}
                    lastLeaf={lastLeaf}
                    checkedKeys={checkedKeys}
                    expandedKeys={expandedKeys}
                    onChange={args => this.handleChange(args, 'customerBaName')}
                />
            </div>
        );
    }
}

export default Filter;


// WEBPACK FOOTER //
// ./src/components/RequestDataAnalysis/RequestToDo/UnregisterRequest/TablePage/Filter.js